module.exports = __webpack_public_path__ + "static/media/leadership-edition-2024.3e862bcf.png";